import React from 'react'
import PropTypes from 'prop-types'
import Timetable from '../../TimeTable'
import HorizontalRule from '../../HorizontalRule'
import Button from '../../Button'
import Flex from '../../Flex'
import Copy from '../../Copy'
import Box from '../../Box'

import PriceContainer from './PriceContainer'


import {
    Container,
    DistanceContainer,
    InfoContainter,
    DistanceText,
} from './layout'
import { FormattedMessage } from 'react-intl'

const LinkElement = ({ url, onClick, children}) => {
    if (url) {
        return <a rel='noopener noreferrer' onClick={onClick} href={url} target={onClick ? null : '_blank' }>{children}</a>
    }

    return <Box onClick={onClick}>{children}</Box>
}
LinkElement.propTypes = {
    children: PropTypes.node,
    url: PropTypes.string,
    onClick: PropTypes.func,
}

const StationCard = React.memo(({
    id,
    isSelected,
    name,
    originalPrice,
    address,
    timetable,
    onlinePrice,
    distance,
    url,
    onClick
}) => (
    <LinkElement url={url} onClick={onClick} data-test={`vehicle-inspection-station-card-${id}`}>
        <Container
            background={isSelected ? 'main10' : 'white'}
            w='100%'
            flexDirection={['column', 'row']}>
            <PriceContainer
                isSelected={isSelected}
                originalPrice={originalPrice}
                distance={distance}
                webPrice={onlinePrice}
            />
            <InfoContainter w='100%' p='1em'>
                <Flex alignItems='center' justifyContent='space-between' >
                    <Flex flex='8' alignItems='center' justifyContent='start'>
                        <Copy textAlign='left' padding='0' fontWeight='medium' transform='uppercase' fontSize='small'>
                            {name}
                        </Copy>
                        <HorizontalRule.vertical background='lightGray30' />
                    </Flex>
                    <DistanceContainer flex='1'>
                        <DistanceText distance={distance} />
                    </DistanceContainer>
                </Flex>
                <Flex justifyContent='space-between'>
                    <Copy.clamp lines='1' mt='0.5em' padding='0' textAlign='left' color='gray' fontWeight='regular' fontSize='small'>
                        {address}
                    </Copy.clamp>

                </Flex>
                <HorizontalRule background='lightGray40' m='0.5em 0' />
                <Flex justifyContent='space-between' alignItems='center'>
                    <Box flex='1'>
                        <Copy textAlign='left' padding='0 0 1em 0' color='gray' fontWeight={['medium', 'regular']} fontSize='xSmall'>
                            {timetable && <Timetable timetables={timetable} />}
                        </Copy>
                    </Box>
                    <Box textAlign='right' flex='1'>
                        <Button.bordered dataTest={`see-more-button-${id}`}>
                            <FormattedMessage id='station-card-select-button' defaultMessage='Seleccionar' />
                        </Button.bordered>
                    </Box>
                </Flex>
            </InfoContainter>
        </Container>
    </LinkElement>
))

StationCard.propTypes = {
    id: PropTypes.number,
    isSelected: PropTypes.bool,
    timetable: PropTypes.object,
    distance: PropTypes.number.isRequired,
    originalPrice: PropTypes.object,
    onlinePrice: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    url: PropTypes.string,
    onClick: PropTypes.func,
}

StationCard.defaultProps = {
    isSelected: false,
    url: '',
    onClick: () => null
}

export default StationCard
